<div (touchstart)="onTouchStart($event)" (touchend)="onTouchEnd($event)">
  <mat-tab-group
    [class]="customClass"
    [(selectedIndex)]="selectedIndex"
    (selectedTabChange)="changeTab($event)"
    animationDuration="0ms">
    @for (tab of tabList; track tab.value) {
      <mat-tab [disabled]="tab.disabled" class="position-relative" tabindex="-1">
        <ng-template mat-tab-label>
          <span class="tabName">{{ tab.name | translate }}</span>
          @if (tab.count) {
            <span class="tabCount">({{ tab.count }})</span>
          }

          @if (tab.dev) {
            <div class="badge-dev">{{'coming_soon' | translate}}!</div>          }

          @if (tab.beta) {
            <div class="badge-beta">{{'test_mode' | translate}}</div>
          }


        </ng-template>

      </mat-tab>
    }
  </mat-tab-group>
</div>
